const  projectsVue = [
    {
       proTitle: "Vue projects", 
       projectProps: [
            {
                title: "progetto Vue 1",
                img: "./img_projects/Vue/1.png",
                desc: "descrizione progetto Vue 1",
                location: "/index.html",
                source_code: true
            },
            {
                title: "progetto Vue 2",
                img: "/img_projects/Vue/1.png",
                desc: "descrizione progetto Vue 2",
                location: "/index.html",
                source_code: true
            },
            {
                title: "progetto Vue 2",
                img: "/img_projects/Vue/1.png",
                desc: "descrizione progetto Vue 2",
                location: "/index.html",
                source_code: true
            },
            {
                title: "progetto Vue 3",
                img: "/img_projects/Vue/1.png",
                desc: "descrizione progetto Vue 3",
                location: "/index.html",
                source_code: true
            }
        ]
    }
]

export {projectsVue}
